/**
 * «Cambió el progreso»: después de algo que mueve la racha sin cambiar de pantalla
 * (un repaso hecho encima del Inicio, card #604), quien muestra la racha y el «hoy
 * ya cuenta» lo vuelve a pedir. Sin esto, el Inicio seguía con el dato de antes
 * del repaso hasta volver a montarse.
 */
const listeners = new Set<() => void>();

/** Se llama cuando cambió algo que cuenta para la racha. */
export function notifyProgressChanged(): void {
  for (const fn of [...listeners]) fn();
}

/** Escucha los cambios; devuelve cómo dejar de escuchar. */
export function onProgressChanged(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
